// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***** frontend/src/pages/SanqiDeviceDetail.css *****/

/* 街机控制台样式 */
.arcade-console {
  font-family: 'Arial', sans-serif;
  animation: console-entrance 1s ease-out;
}

/* 控制台入场动画 */
@keyframes console-entrance {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* 摇杆发光动画 */
@keyframes joystick-glow {
  0% {
    box-shadow: 0 0 30px rgba(138,43,226,0.2), inset 0 4px 15px rgba(0,0,0,0.3);
    opacity: 0.8;
  }
  100% {
    box-shadow: 0 0 50px rgba(138,43,226,0.4), 0 0 80px rgba(255,0,255,0.2), inset 0 4px 15px rgba(0,0,0,0.3);
    opacity: 1;
  }
}

/* 摇杆拖拽时的弹性回弹动画 */
@keyframes joystick-bounce {
  0% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

/* 摇杆球拖拽时的高光增强动画 */
@keyframes joystick-ball-active {
  0% {
    box-shadow: 0 6px 18px rgba(255,68,68,0.4), 0 0 20px rgba(255,68,68,0.3), inset 0 3px 8px rgba(255,255,255,0.4), inset 0 -2px 6px rgba(0,0,0,0.5);
  }
  100% {
    box-shadow: 0 10px 25px rgba(255,68,68,0.6), 0 0 40px rgba(255,68,68,0.5), 0 0 60px rgba(255,68,68,0.2), inset 0 3px 8px rgba(255,255,255,0.6), inset 0 -2px 6px rgba(0,0,0,0.7);
  }
}

/* AUTO按钮脉冲动画 */
@keyframes auto-pulse {
  0% {
    box-shadow: 0 0 40px rgba(255,140,68,0.3), 0 0 80px rgba(255,140,68,0.15);
    opacity: 0.9;
  }
  100% {
    box-shadow: 0 0 60px rgba(255,140,68,0.5), 0 0 120px rgba(255,140,68,0.3);
    opacity: 1;
  }
}

/* HOME按钮发光动画 */
@keyframes home-glow {
  0% {
    box-shadow: 0 0 25px rgba(68,255,68,0.2);
    opacity: 0.7;
  }
  100% {
    box-shadow: 0 0 40px rgba(68,255,68,0.4), 0 0 60px rgba(0,255,255,0.2);
    opacity: 1;
  }
}

/* MAX按钮脉冲动画 */
@keyframes max-pulse {
  0% {
    box-shadow: 0 0 30px rgba(255,215,0,0.3), 0 0 60px rgba(255,215,0,0.15);
    opacity: 0.9;
  }
  100% {
    box-shadow: 0 0 50px rgba(255,215,0,0.5), 0 0 100px rgba(255,215,0,0.3);
    opacity: 1;
  }
}

/* 脉冲动画 */
@keyframes pulse {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.02);
  }
  100% {
    opacity: 0.8;
    transform: scale(1);
  }
}

/* 摇杆动画效果 */
.joystick-container .joystick:hover {
  box-shadow: 0 15px 35px rgba(0,0,0,0.8), inset 0 3px 15px rgba(255,255,255,0.2), 0 0 20px rgba(138,43,226,0.3) !important;
  transform: scale(1.05) !important;
}

.joystick-container .joystick:active {
  transform: scale(0.92) !important;
}

/* 按钮点击效果 */
.action-btn:hover {
  transform: translateY(-2px) scale(1.05) !important;
}

.action-btn:active {
  transform: translateY(4px) scale(0.95) !important;
}

.auto-btn:hover:not(:disabled) {
  transform: translateY(-3px) scale(1.02) !important;
}

.auto-btn:active:not(:disabled) {
  transform: translateY(8px) scale(0.92) !important;
}

.auto-btn:disabled {
  opacity: 0.6;
  filter: grayscale(0.5);
}

/* 返回按钮效果 */
.return-container button:hover {
  transform: translateY(-2px) scale(1.05) !important;
}

.return-container button:active {
  transform: translateY(4px) scale(0.95) !important;
}

/* 控制台整体发光效果 */
.arcade-console::before {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(135deg, 
    rgba(138,43,226,0.1) 0%, 
    rgba(255,0,255,0.05) 25%, 
    rgba(0,255,255,0.05) 50%, 
    rgba(255,215,0,0.05) 75%, 
    rgba(138,43,226,0.1) 100%);
  border-radius: 40px 40px 30px 30px;
  z-index: -2;
  animation: console-aura 4s ease-in-out infinite alternate;
}

@keyframes console-aura {
  0% {
    opacity: 0.3;
    transform: scale(1);
  }
  100% {
    opacity: 0.6;
    transform: scale(1.02);
  }
}

/* 按钮涟漪效果 */
.action-btn::after,
.auto-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  transform: translate(-50%, -50%);
  transition: all 0.3s ease;
  pointer-events: none;
}

.action-btn:active::after,
.auto-btn:active::after {
  width: 100%;
  height: 100%;
  opacity: 0;
}

/* 按钮按下时的触觉反馈 */
.action-btn:active,
.auto-btn:active:not(:disabled),
.return-container button:active {
  transition: all 0.1s ease !important;
}

/* 移动端底部控制台全屏固定 */
@media (max-width: 768px) {
  .arcade-console {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    height: auto !important;
    padding: 10px 20px 80px 20px !important; /* 底部预留空间，避免Home按钮被遮挡 */
    box-sizing: border-box;
    overflow: visible !important; /* 允许溢出显示Home按钮 */
    transform: none !important;
    border-radius: 0 !important;
    margin: 0 !important;
  }
  /* 移动端按钮布局优化：换行并居中 */
  .action-buttons {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 15px !important;
    margin-top: 10px !important;
  }
  /* 顶部状态栏固定并紧凑 */
  .sanqiInfoOverlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1100 !important;
    padding: 6px 8px !important;
    background: rgba(0,0,0,0.95) !important;
  }
  .sanqiInfoOverlay > div:first-child {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 6px !important;
    overflow-x: auto !important;
    white-space: nowrap !important;
  }
  
  .joystick {
    width: 70px !important;
    height: 70px !important;
  }
  
  .action-btn {
    width: 45px !important;
    height: 45px !important;
    font-size: 14px !important;
  }
  
  .auto-btn {
    width: 80px !important;
    height: 80px !important;
    font-size: 16px !important;
  }
  
  .return-container button {
    width: 55px !important;
    height: 55px !important;
    font-size: 18px !important;
  }
}

@media (max-width: 480px) {
  .arcade-console {
    min-width: 95% !important;
    padding: 20px 25px 25px 25px !important;
  }
  
  .arcade-console > div:last-child {
    gap: 30px !important;
  }
  
  .joystick {
    width: 60px !important;
    height: 60px !important;
  }
  
  .action-btn {
    width: 40px !important;
    height: 40px !important;
    font-size: 12px !important;
  }
  
  .auto-btn {
    width: 70px !important;
    height: 70px !important;
    font-size: 14px !important;
  }
  
  .return-container button {
    width: 50px !important;
    height: 50px !important;
    font-size: 16px !important;
  }
  
  .action-buttons {
    gap: 15px !important;
  }
  
  .action-buttons > div:first-child {
    gap: 10px !important;
  }
}

/* 禁用状态样式 */
.auto-btn:disabled {
  cursor: not-allowed !important;
  filter: grayscale(0.5);
}

/* 状态指示器动画 */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.arcade-console .status-indicator {
  animation: pulse 2s infinite;
}

/* 特殊光效 */
@keyframes rainbow-border {
  0% { border-color: rgba(255,0,0,0.5); }
  16% { border-color: rgba(255,165,0,0.5); }
  33% { border-color: rgba(255,255,0,0.5); }
  50% { border-color: rgba(0,255,0,0.5); }
  66% { border-color: rgba(0,0,255,0.5); }
  83% { border-color: rgba(138,43,226,0.5); }
  100% { border-color: rgba(255,0,0,0.5); }
}

/* 动态边框效果 */
.arcade-console.active-session {
  border: 3px solid rgba(255,215,0,0.5);
  animation: rainbow-border 3s linear infinite;
}

/* 增强视觉层次 */
.arcade-console * {
  transition: all 0.15s ease;
}

/* 摇杆容器 - 增强视觉层次 */
.joystick-container {
  position: relative;
}

.joystick-container::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(138,43,226,0.1) 0%, transparent 70%);
  border: 1px solid rgba(138,43,226,0.2);
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SanqiDeviceDetail.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,YAAY;AACZ;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA,YAAY;AACZ;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,WAAW;AACX;EACE;IACE,2EAA2E;IAC3E,YAAY;EACd;EACA;IACE,yGAAyG;IACzG,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,iJAAiJ;EACnJ;EACA;IACE,gLAAgL;EAClL;AACF;;AAEA,eAAe;AACf;EACE;IACE,yEAAyE;IACzE,YAAY;EACd;EACA;IACE,yEAAyE;IACzE,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;EACE;IACE,wCAAwC;IACxC,YAAY;EACd;EACA;IACE,sEAAsE;IACtE,UAAU;EACZ;AACF;;AAEA,cAAc;AACd;EACE;IACE,uEAAuE;IACvE,YAAY;EACd;EACA;IACE,uEAAuE;IACvE,UAAU;EACZ;AACF;;AAEA,SAAS;AACT;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA,WAAW;AACX;EACE,yHAAyH;EACzH,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb;;;;;8BAK4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,eAAe;AACf;;;EAGE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,uCAAuC,EAAE,uBAAuB;IAChE,sBAAsB;IACtB,4BAA4B,EAAE,iBAAiB;IAC/C,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;EACtB;EACA,oBAAoB;EACpB;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,kCAAkC;IAClC,oBAAoB;IACpB,2BAA2B;EAC7B;EACA,eAAe;EACf;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,uCAAuC;EACzC;EACA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,uCAAuC;EACzC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,KAAK,+BAA+B,EAAE;EACtC,MAAM,iCAAiC,EAAE;EACzC,MAAM,iCAAiC,EAAE;EACzC,MAAM,+BAA+B,EAAE;EACvC,MAAM,+BAA+B,EAAE;EACvC,MAAM,kCAAkC,EAAE;EAC1C,OAAO,+BAA+B,EAAE;AAC1C;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,WAAW;AACX;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6EAA6E;EAC7E,sCAAsC;EACtC,UAAU;AACZ","sourcesContent":["/***** frontend/src/pages/SanqiDeviceDetail.css *****/\n\n/* 街机控制台样式 */\n.arcade-console {\n  font-family: 'Arial', sans-serif;\n  animation: console-entrance 1s ease-out;\n}\n\n/* 控制台入场动画 */\n@keyframes console-entrance {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* 摇杆发光动画 */\n@keyframes joystick-glow {\n  0% {\n    box-shadow: 0 0 30px rgba(138,43,226,0.2), inset 0 4px 15px rgba(0,0,0,0.3);\n    opacity: 0.8;\n  }\n  100% {\n    box-shadow: 0 0 50px rgba(138,43,226,0.4), 0 0 80px rgba(255,0,255,0.2), inset 0 4px 15px rgba(0,0,0,0.3);\n    opacity: 1;\n  }\n}\n\n/* 摇杆拖拽时的弹性回弹动画 */\n@keyframes joystick-bounce {\n  0% {\n    transform: scale(1.1);\n  }\n  50% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* 摇杆球拖拽时的高光增强动画 */\n@keyframes joystick-ball-active {\n  0% {\n    box-shadow: 0 6px 18px rgba(255,68,68,0.4), 0 0 20px rgba(255,68,68,0.3), inset 0 3px 8px rgba(255,255,255,0.4), inset 0 -2px 6px rgba(0,0,0,0.5);\n  }\n  100% {\n    box-shadow: 0 10px 25px rgba(255,68,68,0.6), 0 0 40px rgba(255,68,68,0.5), 0 0 60px rgba(255,68,68,0.2), inset 0 3px 8px rgba(255,255,255,0.6), inset 0 -2px 6px rgba(0,0,0,0.7);\n  }\n}\n\n/* AUTO按钮脉冲动画 */\n@keyframes auto-pulse {\n  0% {\n    box-shadow: 0 0 40px rgba(255,140,68,0.3), 0 0 80px rgba(255,140,68,0.15);\n    opacity: 0.9;\n  }\n  100% {\n    box-shadow: 0 0 60px rgba(255,140,68,0.5), 0 0 120px rgba(255,140,68,0.3);\n    opacity: 1;\n  }\n}\n\n/* HOME按钮发光动画 */\n@keyframes home-glow {\n  0% {\n    box-shadow: 0 0 25px rgba(68,255,68,0.2);\n    opacity: 0.7;\n  }\n  100% {\n    box-shadow: 0 0 40px rgba(68,255,68,0.4), 0 0 60px rgba(0,255,255,0.2);\n    opacity: 1;\n  }\n}\n\n/* MAX按钮脉冲动画 */\n@keyframes max-pulse {\n  0% {\n    box-shadow: 0 0 30px rgba(255,215,0,0.3), 0 0 60px rgba(255,215,0,0.15);\n    opacity: 0.9;\n  }\n  100% {\n    box-shadow: 0 0 50px rgba(255,215,0,0.5), 0 0 100px rgba(255,215,0,0.3);\n    opacity: 1;\n  }\n}\n\n/* 脉冲动画 */\n@keyframes pulse {\n  0% {\n    opacity: 0.8;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.02);\n  }\n  100% {\n    opacity: 0.8;\n    transform: scale(1);\n  }\n}\n\n/* 摇杆动画效果 */\n.joystick-container .joystick:hover {\n  box-shadow: 0 15px 35px rgba(0,0,0,0.8), inset 0 3px 15px rgba(255,255,255,0.2), 0 0 20px rgba(138,43,226,0.3) !important;\n  transform: scale(1.05) !important;\n}\n\n.joystick-container .joystick:active {\n  transform: scale(0.92) !important;\n}\n\n/* 按钮点击效果 */\n.action-btn:hover {\n  transform: translateY(-2px) scale(1.05) !important;\n}\n\n.action-btn:active {\n  transform: translateY(4px) scale(0.95) !important;\n}\n\n.auto-btn:hover:not(:disabled) {\n  transform: translateY(-3px) scale(1.02) !important;\n}\n\n.auto-btn:active:not(:disabled) {\n  transform: translateY(8px) scale(0.92) !important;\n}\n\n.auto-btn:disabled {\n  opacity: 0.6;\n  filter: grayscale(0.5);\n}\n\n/* 返回按钮效果 */\n.return-container button:hover {\n  transform: translateY(-2px) scale(1.05) !important;\n}\n\n.return-container button:active {\n  transform: translateY(4px) scale(0.95) !important;\n}\n\n/* 控制台整体发光效果 */\n.arcade-console::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: -10px;\n  right: -10px;\n  bottom: -10px;\n  background: linear-gradient(135deg, \n    rgba(138,43,226,0.1) 0%, \n    rgba(255,0,255,0.05) 25%, \n    rgba(0,255,255,0.05) 50%, \n    rgba(255,215,0,0.05) 75%, \n    rgba(138,43,226,0.1) 100%);\n  border-radius: 40px 40px 30px 30px;\n  z-index: -2;\n  animation: console-aura 4s ease-in-out infinite alternate;\n}\n\n@keyframes console-aura {\n  0% {\n    opacity: 0.3;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0.6;\n    transform: scale(1.02);\n  }\n}\n\n/* 按钮涟漪效果 */\n.action-btn::after,\n.auto-btn::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.3);\n  transform: translate(-50%, -50%);\n  transition: all 0.3s ease;\n  pointer-events: none;\n}\n\n.action-btn:active::after,\n.auto-btn:active::after {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n\n/* 按钮按下时的触觉反馈 */\n.action-btn:active,\n.auto-btn:active:not(:disabled),\n.return-container button:active {\n  transition: all 0.1s ease !important;\n}\n\n/* 移动端底部控制台全屏固定 */\n@media (max-width: 768px) {\n  .arcade-console {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    height: auto !important;\n    padding: 10px 20px 80px 20px !important; /* 底部预留空间，避免Home按钮被遮挡 */\n    box-sizing: border-box;\n    overflow: visible !important; /* 允许溢出显示Home按钮 */\n    transform: none !important;\n    border-radius: 0 !important;\n    margin: 0 !important;\n  }\n  /* 移动端按钮布局优化：换行并居中 */\n  .action-buttons {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    justify-content: center !important;\n    gap: 15px !important;\n    margin-top: 10px !important;\n  }\n  /* 顶部状态栏固定并紧凑 */\n  .sanqiInfoOverlay {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 1100 !important;\n    padding: 6px 8px !important;\n    background: rgba(0,0,0,0.95) !important;\n  }\n  .sanqiInfoOverlay > div:first-child {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    gap: 6px !important;\n    overflow-x: auto !important;\n    white-space: nowrap !important;\n  }\n  \n  .joystick {\n    width: 70px !important;\n    height: 70px !important;\n  }\n  \n  .action-btn {\n    width: 45px !important;\n    height: 45px !important;\n    font-size: 14px !important;\n  }\n  \n  .auto-btn {\n    width: 80px !important;\n    height: 80px !important;\n    font-size: 16px !important;\n  }\n  \n  .return-container button {\n    width: 55px !important;\n    height: 55px !important;\n    font-size: 18px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .arcade-console {\n    min-width: 95% !important;\n    padding: 20px 25px 25px 25px !important;\n  }\n  \n  .arcade-console > div:last-child {\n    gap: 30px !important;\n  }\n  \n  .joystick {\n    width: 60px !important;\n    height: 60px !important;\n  }\n  \n  .action-btn {\n    width: 40px !important;\n    height: 40px !important;\n    font-size: 12px !important;\n  }\n  \n  .auto-btn {\n    width: 70px !important;\n    height: 70px !important;\n    font-size: 14px !important;\n  }\n  \n  .return-container button {\n    width: 50px !important;\n    height: 50px !important;\n    font-size: 16px !important;\n  }\n  \n  .action-buttons {\n    gap: 15px !important;\n  }\n  \n  .action-buttons > div:first-child {\n    gap: 10px !important;\n  }\n}\n\n/* 禁用状态样式 */\n.auto-btn:disabled {\n  cursor: not-allowed !important;\n  filter: grayscale(0.5);\n}\n\n/* 状态指示器动画 */\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.arcade-console .status-indicator {\n  animation: pulse 2s infinite;\n}\n\n/* 特殊光效 */\n@keyframes rainbow-border {\n  0% { border-color: rgba(255,0,0,0.5); }\n  16% { border-color: rgba(255,165,0,0.5); }\n  33% { border-color: rgba(255,255,0,0.5); }\n  50% { border-color: rgba(0,255,0,0.5); }\n  66% { border-color: rgba(0,0,255,0.5); }\n  83% { border-color: rgba(138,43,226,0.5); }\n  100% { border-color: rgba(255,0,0,0.5); }\n}\n\n/* 动态边框效果 */\n.arcade-console.active-session {\n  border: 3px solid rgba(255,215,0,0.5);\n  animation: rainbow-border 3s linear infinite;\n}\n\n/* 增强视觉层次 */\n.arcade-console * {\n  transition: all 0.15s ease;\n}\n\n/* 摇杆容器 - 增强视觉层次 */\n.joystick-container {\n  position: relative;\n}\n\n.joystick-container::before {\n  content: '';\n  position: absolute;\n  top: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(138,43,226,0.1) 0%, transparent 70%);\n  border: 1px solid rgba(138,43,226,0.2);\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
